import React from "react";
import { DatePicker as DatePickerMui } from "@mui/x-date-pickers/DatePicker";
import { useStyles } from "./style";
import { CalendarIcon, StarIcon } from "./icons";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Box } from "@mui/material";

interface DatePickerProps {
  label: string;
  placeholder?: string;
  value?: string;
  onChangeDate: (date: string) => void;
  required?: boolean;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  label,
  placeholder,
  value,
  onChangeDate,
  required,
}) => {
  const date = value ? dayjs(value, "MM/DD/YYYY") : null;
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.label}>
        <Box className={classes.labelText}>{label}</Box>
        {required && (
          <Box className={classes.icon}>
            <StarIcon width={6.957} height={7.875} />
          </Box>
        )}
      </Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePickerMui
          className={classes.datePicker}
          label=""
          value={date}
          onChange={(newValue) => {
            const formattedDate = newValue ? newValue.format("MM/DD/YYYY") : "";
            onChangeDate(formattedDate);
          }}
          disableFuture
          slots={{ openPickerIcon: CalendarIcon }}
          slotProps={{
            openPickerIcon: {
              width: 24,
              height: 24,
            },
            desktopPaper: {
              sx: {
                backgroundColor: "white",
              },
            },
            textField: {
              placeholder: placeholder || "",
              variant: "outlined",
              sx: {
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  height: "44px",
                  fontSize: "14px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B9BEC7",
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};
